// Negocio activo de la sesión. Los services lo consultan en lugar de
// un ID hardcodeado (multi-tenant: PRODUCT_VISION cap. 2.5 y 3.4).
let negocioId = null;

export function setNegocioId(id) {
  negocioId = id;
}

export function getNegocioId() {
  if (!negocioId) {
    throw new Error('No hay negocio activo. Inicia sesión de nuevo.');
  }
  return negocioId;
}

// Código telefónico del país del negocio (para WhatsApp a números locales).
// Multi-país: se setea al cargar la sesión; por defecto Honduras (504).
let codigoPais = '504';

export function setCodigoPais(c) {
  codigoPais = (c || '504').replace(/\D/g, '') || '504';
}

export function getCodigoPais() {
  return codigoPais;
}

// Moneda del negocio activo (multi-país). Se setea al cargar la sesión y al
// guardar Configuración. Por defecto Lempira (compatibilidad con HN).
let moneda = 'HNL';

export function setMoneda(m) {
  moneda = (m || 'HNL').trim() || 'HNL';
}

export function getMoneda() {
  return moneda;
}

// Símbolo corto de una moneda (para mostrar el dinero). Si no se pasa código,
// usa la moneda del negocio activo. Si no se reconoce, usa el propio código.
const SIMBOLOS = {
  HNL: 'L', USD: '$', MXN: '$', GTQ: 'Q', NIO: 'C$', CRC: '₡', COP: '$',
  DOP: 'RD$', EUR: '€', PEN: 'S/', ARS: '$', CLP: '$', BOB: 'Bs', PYG: '₲',
  UYU: '$U', BRL: 'R$', CAD: '$',
};

export function simboloMoneda(codigo) {
  const c = (codigo || moneda || 'HNL').trim();
  return SIMBOLOS[c] || c;
}
